import * as types from '../actions/actionTypes';
export default function fundingpreorderReducer(state: any = {}, action: any) {
  switch (action.type) {
    case types.FUNDS_SET:
      return { ...state, funds: action.funds };
    default:
      return state;
  }
}